import React, { useEffect } from "react";
import "./ExpenseManagment.scss";
import SoftButton from "StyleFeatures/SoftButton";
import DashboardLayout from "../LayoutNavbar/LayoutContainers/DashboardLayout";
import DashboardNavbar from "../LayoutNavbar/Navbars/DashboardNavbar";
import ExpenseManagementService from "../EmployeeApiService/ExpenseManageService";
import { useNavigate } from "react-router-dom";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

function ExpenseManagement() {
  const {
    formData,
    formDataError,
    handleChange,
    isLoading,
    handleAddExpense,
    handleUploadDocChange,
    handleUploadCalculationDoc,
  } = ExpenseManagementService();

  const navigate = useNavigate();


  const handleCancelExpense = () => {
    navigate("/employeedashboard/expenseManagement");
  };

  return (
    <DashboardLayout>
      <div className="wrapper d-flex flex-column min-vh-100 bg-light">
        <DashboardNavbar />
        <ToastContainer />
        <div className="body flex-grow-1 px-3">
          <div className="card">
            <div className="card-header" style={{ position: "relative" }}>
              <h5>Add Expense</h5>
            </div>

            <div className="card-body">
           

              {/* Row 1: Date + Description */}
              <div className="row">
                <div className="col-md-5">
                  <div className="mb-3">
                    <label className="form-label" style={{ fontSize: "medium" }}>
                      Request Date *
                    </label>
                    <input
                      type="date"
                      name="Date"
                      value={formData.Date || ""}
                      onChange={handleChange}
                      className={`form-control ${formDataError.DateError ? "is-invalid" : ""}`}
                    />
                    {formDataError.DateError && (
                      <div className="invalid-feedback invalid-message">
                        {formDataError.DateError}
                      </div>
                    )}
                  </div>
                </div>

                <div className="col-md-4">
                  <div className="mb-3">
                    <label className="form-label" style={{ fontSize: "medium" }}>
                      Description *
                    </label>
                    <input
                      type="text"
                      placeholder="Enter description here"
                      name="Description"
                      value={formData.Description || ""}
                      onChange={handleChange}
                      className={`form-control ${
                        formDataError.descriptionError ? "is-invalid" : ""
                      }`}
                    />
                    {formDataError.descriptionError && (
                      <div className="invalid-feedback invalid-message">
                        {formDataError.descriptionError}
                      </div>
                    )}
                  </div>
                </div>
              </div>

              {/* Row 3: Department + Charges */}
              <div className="row">
              

                <div className="col-md-4">
                  <div className="mb-3">
                    <label className="form-label" style={{ fontSize: "medium" }}>
                      Charges *
                    </label>
                    <input
                      type="number"
                      placeholder="Enter charges here"
                      name="Charges"
                      value={formData.Charges || ""}
                      onChange={handleChange}
                      className={`form-control ${formDataError.chargesError ? "is-invalid" : ""}`}
                    />
                    {formDataError.chargesError && (
                      <div className="invalid-feedback invalid-message">
                        {formDataError.chargesError}
                      </div>
                    )}
                  </div>
                </div>
              </div>

              {/* Row 4: Receipt + Calculation Sheet */}
              <div className="row">
                <div className="col-md-5">
                  <div className="mb-3">
                    <label className="form-label" style={{ fontSize: "medium" }}>
                      Receipt *
                    </label>
                    <input
                      type="file"
                      accept=".pdf,.doc,.docx"
                      onChange={(e) => {
                        handleUploadDocChange(e);
                        // Clear file input if there's an error
                        if (formDataError.receiptError) {
                          e.target.value = "";
                        }
                      }}
                      className={`form-control ${formDataError.receiptError ? "is-invalid" : ""}`}
                    />

                    {formDataError.receiptError && (
                      <div className="invalid-feedback invalid-message">
                        {formDataError.receiptError}
                      </div>
                    )}
                  </div>
                </div>

                <div className="col-md-4">
                  <div className="mb-3">
                    <label className="form-label" style={{ fontSize: "medium" }}>
                      Expense Sheet *
                    </label>
                    {/* Calculation Sheet */}
                    <input
                      type="file"
                      accept=".xls,.xlsx,.csv"
                      onChange={(e) => {
                        handleUploadCalculationDoc(e);
                        if (formDataError.calculationSheetError) {
                          e.target.value = "";
                        }
                      }}
                      className={`form-control ${
                        formDataError.calculationSheetError ? "is-invalid" : ""
                      }`}
                    />

                    {formDataError.calculationSheetError && (
                      <div className="invalid-feedback invalid-message">
                        {formDataError.calculationSheetError}
                      </div>
                    )}
                  </div>
                </div>
              </div>

              {/* Buttons */}
              <div className="col-md-9">
                <SoftButton
                  variant="outlined"
                  style={{ float: "inline-end" }}
                  color="info"
                  size="small"
                  onClick={handleAddExpense}
                >
                  {isLoading ? (
                    <>
                      Submitting...
                      <span
                        className="spinner-border spinner-border-sm"
                        role="status"
                        aria-hidden="true"
                      ></span>
                    </>
                  ) : (
                    "Submit"
                  )}
                </SoftButton>
                <SoftButton
                  variant="outlined"
                  className="btn-cancel"
                  size="small"
                  onClick={handleCancelExpense}
                >
                  Cancel
                </SoftButton>
              </div>
            </div>
          </div>
        </div>
      </div>
    </DashboardLayout>
  );
}

export default ExpenseManagement;
